<template>
  <Head title="Manage Subscription" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <manage-subscription
            :subscription-id="subscriptionId"
            :subscription-data="subscription"
            :initial-clients="clients"
            :initial-agencies="agencies"
          />
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../../Layouts/AppLayout.vue';

defineProps({
  subscriptionId: {
    type: String,
    default: null
  },
  subscription: {
    type: Object,
    default: null
  },
  clients: Array,
  agencies: Array
});
</script>

